import {html, type TemplateResult} from "lit";
import {unsafeHTML} from "lit/directives/unsafe-html.js";

export type HeadlineLevel = `h${1 | 2 | 3 | 4 | 5 | 6}`;
export type HeadlineSize = "" | "h1-xl" | "h1-xxl" | "h1-xxxl";

const HEADLINE_LEVELS: Record<string, HeadlineLevel> = {
    "H1_XXXL": "h1",
    "H1_XXXL_WITH_OVERLINE": "h1",
    "H1_XXL": "h1",
    "H1_XXL_WITH_OVERLINE": "h1",
    "H1_XL": "h1",
    "H1_XL_WITH_OVERLINE": "h1",
    "H1": "h1",
    "H1_WITH_OVERLINE": "h1",
    "H2": "h2",
    "H2_WITH_OVERLINE": "h2",
    "H3": "h3",
    "H4": "h4",
    "H5": "h5"
};

const HEADLINE_SIZES: Record<string, HeadlineSize> = {
    "H1_XL": "h1-xl",
    "H1_XL_WITH_OVERLINE": "h1-xl",
    "H1_XXL": "h1-xxl",
    "H1_XXL_WITH_OVERLINE": "h1-xxl",
    "H1_XXXL": "h1-xxxl",
    "H1_XXXL_WITH_OVERLINE": "h1-xxxl"
};

export function headlineLevel(levelString: string): HeadlineLevel {
    return HEADLINE_LEVELS[levelString] ?? "h6";
}

export function headlineSize(levelString: string): HeadlineSize {
    return HEADLINE_SIZES[levelString] ?? "";
}

export function headline(level: HeadlineLevel, content: string, classes: string[] = []): TemplateResult {
    return html`
        <div class="h ${level} ${classes.join(" ")}">${unsafeHTML(content)}</div>
    `;
}